module.exports = __webpack_public_path__ + "media/packs/images/partners/planetakino_logo-495c34e2443788adf7e8e45b7479bc2d.png";